/// <reference path="../../../Common/Helpers/GridEditorDialog.ts" />

namespace Matrix {

    @Serenity.Decorators.registerEditor([Serenity.IReadOnly, Serenity['IStringValue']])
    @Serenity.Decorators.element("<select/>")
    export class CustomDateEditor extends Serenity.Widget<CustomDateEditorOptions> implements Serenity.IReadOnly, Serenity.IStringValue, Serenity.IValidateRequired {

        private input: JQuery;

        constructor(select: JQuery, options: CustomDateEditorOptions) {
            super(select, options);

            select.addClass('kind');
            Q.clearOptions(select);
            Q.addOption(select, "", "Date");
            for (var k of Data.ListItemRow.getLookup()
                .items.filter(x => x.ListCode == "REP_PARM_CUSTOM_DATES"))
                Q.addOption(select, k.ListItemCode, k.ListItemText);
        
            this.input = $('<input/>').addClass('dateQ s-CustomDateEditor').insertAfter(select);
  
            this.input.datepicker(<any>{
                showOn: 'button',
                beforeShow: (e, x) => {
                    return !select.is(':disabled') && !this.element.val();
                }
            });

            this.input.bind('keyup.' + this.uniqueName, e => {
                if (e.which === 32 && !this.input.attr('readonly')) {
                    this.set_value(Q.formatDate(new Date()));
                }
                else {
                    Serenity.DateEditor.dateInputKeyup(e);
                }
            });

            this.element.bind('change.' + this.uniqueName, e => {
                if (this.element.val()) {
                    this.input.val('');
                    this.setCalculatedDate();   
                }

                this.updateRequired();
                this.updateInputReadOnly();
    
            });

            this.updateInputReadOnly();

            this.input.bind('change.' + this.uniqueName, Serenity.DateEditor.dateInputChange);

            this.addValidationRule(this.uniqueName, e => {
                if (this.element.val() || Q.isTrimmedEmpty(this.input.val()))
                    return null;

                var value = Q.formatDate(this.input.val(), 'yyyy-MM-dd');
                if (this.options.minValue && value < this.options.minValue) {
                    return Q.format(Q.text('Validation.MinDate'), Q.formatDate(this.options.minValue));
                }
                if (this.options.maxValue && value > this.options.maxValue) {
                    return Q.format(Q.text('Validation.MaxDate'), Q.formatDate(this.options.maxValue));
                }
            });

            this.options.minValue = this.options.minValue || '1753-01-01';
            this.options.maxValue = this.options.maxValue || '9999-12-31';

            window.setTimeout(() => {
                this.setCalculatedDate();
                var elInstanceCode = Q.findElementWithRelativeId(this.element, "instance_code");
                elInstanceCode.change(() => this.setCalculatedDate());
            }, 0);
        }

        get_required(): boolean {
            return this.element.hasClass('required') || this.input.hasClass('required');
        }

        set_required(value: boolean): void {
            this.element.toggleClass('required', !!value);
            this.input.toggleClass('required', !!value);
        }

        setCalculatedDate() {
            var kind = this.element.val();

            if (!kind || !this.options.sourceData)
                return;

            var elInstanceCode = Q.findElementWithRelativeId(this.element, "instance_code");
            if (!elInstanceCode .length)
                return;

            var instanceCode = elInstanceCode.val();
            if (!instanceCode) {
                this.input.val('');
                return;
            }

            Data.DataReportsService.GetCustomDate({
                InstanceCode: instanceCode,
                Kind: kind,
                SourceData: this.options.sourceData
            }, response => {
                this.input.val(Q.formatDate(response.Date));
            });
        }

        get_readOnly() {
            return !!this.element.attr('disabled');
        }

        updateInputReadOnly() {
            if (this.get_readOnly() || this.element.val()) {
                this.input.addClass('readonly').attr('readonly', 'readonly');
                this.input.nextAll('.ui-datepicker-trigger').css('opacity', '0.1');
            }
            else {
                this.input.removeAttr('readonly').removeClass('readonly');
                this.input.nextAll('.ui-datepicker-trigger').css('opacity', '1');
            }
        }

        updateRequired() {
            if (this.element.val()) {
                if (this.input.hasClass("required"))
                    this.input.removeClass("required");

                if (!this.element.hasClass("required"))
                    this.element.addClass("required");
            } else {
                if (!this.input.hasClass("required"))
                    this.input.addClass("required");

                if (this.element.hasClass("required"))
                    this.element.removeClass("required");
            }
        }

        set_readOnly(value) {
            if (value != this.get_readOnly()) {
                if (value) 
                    this.element.attr('disabled', 'disabled');
                else
                    this.element.removeAttr('disabled');

                this.updateInputReadOnly();
            }
        }

        addDashes(value: string) {
            if (value && value.length == 8)
                return value.substr(0, 4) + '-' + value.substr(4, 2) + '-' + value.substr(6, 2);

            return value;
        }

        get_value() {
            var value = this.element.val();
            if (value)
                return value;

            value = Q.trimToNull(this.input.val());
            if (!value)
                return null;

            return Q.formatDate(value, 'yyyyMMdd');
        }

        set_value(value: string) {
            if (!value) {
                this.element.val('');
                this.input.val('');
            }
            else if (value.toLowerCase() === 'today' || value.toLowerCase() === 'now') {
                this.element.val('');
                this.input.val(Q.formatDate(new Date()));
            }
            else if (this.element.children('option').filter((x, e) => $(e).attr('value').toLowerCase() == value.toLowerCase()).length) {
                this.element.val(value);
                this.input.val('');
            }
            else {
                this.element.val('');
                this.input.val(Q.formatDate(this.addDashes(value), null));
            }

            this.updateRequired()
            this.updateInputReadOnly();
        }
    }

    export interface CustomDateEditorOptions {
        minValue: string;
        maxValue: string;
        sourceData: Data.CustomDateSourceData;
    }
}